$(function() {

$(".downloadbutton").click(function(event){
	$.getJSON("/palettes/getpalette", {
		"hashid": $(this).closest(".rowitem").data("id")
	}, function(ret){
		var str = localstorage_get("palettes");
		
		try {
			var arr = JSON.parse(str);
		} catch(err) {
			alert(err);
			
			return;
		}		
		
		arr = arr || [];
		ret.colors = ret.colors.split(",");
		if( (!ret.descr && ret.descr != "") || ret.colors.length != 12 ){
			alert("ret error");
			
			return;
			
		}
		arr.push({
			"name": ret.descr,
			"colors": ret.colors
		});
		
		localstorage_set("paletteswritetime", Date.now());
		localstorage_set("palettes", JSON.stringify(arr));
		
		alert("Palette was added")
	})
	
});


$(".deletebutton").click(function(event){
	$.post("/palettes/delete", {
		"hashid": $(this).closest(".rowitem").data("id")
	}, obj => {
		if( obj && obj.result == "ok" ){
			$(this).closest(".rowitem").css("visibility", "hidden");
		}
	})
	
})

});



function localstorage_get(k){
		
		try {
			
			return localStorage.getItem(k);
			
		} catch(err) {}
	}
	
function localstorage_set(k, v){
	
	try {
		
		return localStorage.setItem(k, v);
		
	} catch(err) {}
}